module.exports = __webpack_public_path__ + "a71d45994c6ecdd796bb7e8c46ceba58.png";